<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "App",
  methods: {
    ...mapActions(["getBucketData"])
  },
  mounted() {
    // 初始化时获取bucket数据（对齐galaxy）
    this.getBucketData().catch((error) => {
      console.error("获取bucket数据失败:", error);
    });
  }
};
</script>

<style lang="scss" scoped>
#app {
  height: 100%;
}
</style>
